module.exports = __webpack_public_path__ + "static/media/03_BOJO_MEIA_TACA_LISO_03.d755afea.jpg";